import { Link as RouterLink } from 'react-router-dom';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import React from 'react';
import Url from 'url';
import classnames from 'classnames';

const propTypes = {
  activeClass: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  exact: PropTypes.bool,
  external: PropTypes.bool,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  onClick: PropTypes.func,
  title: PropTypes.string,
  to: PropTypes.string,
};

class Link extends React.Component {
  constructor() {
    super();
    this.state = {
      isLocal: false,
    };
  }

  /* eslint-disable react/no-did-mount-set-state */
  componentDidMount() {
    const { to, external } = this.props;
    if (to && typeof window !== 'undefined') {
      const url = Url.parse(to);
      if (
        !external
        && (window.location.hostname === url.hostname || !url.hostname || !url.hostname.length)
      ) {
        this.setState({
          isLocal: true,
          localTo: to.replace('www.', '').replace(window.location.origin, ''),
        });
      }
    }
  }
  /* eslint-enable */

  render() {
    const {
      to, className, children, location, activeClass, onClick, exact, title,
    } = this.props;
    const { isLocal, localTo } = this.state;
    const active = localTo
      && activeClass
      && (
        (exact && location.pathname === localTo)
        || (!exact && location.pathname.substring(0, localTo.length) === localTo)
      ) ? activeClass : null;

    return (
      isLocal
        ? (
          <RouterLink
            to={localTo}
            className={classnames([className, active])}
            onClick={onClick}
            title={title}
          >
            {children}
          </RouterLink>
        )
        : (
          <a
            href={to}
            className={className}
            onClick={onClick}
            title={title}
          >
            {children}
          </a>
        )
    );
  }
}

Link.propTypes = propTypes;
Link.defaultProps = {
  exact: true,
  external: false,
};

export default withRouter(Link);
